import { Field } from "formik";
import React, { useState } from "react";
import * as yup from "yup";
import DefaultActionButtonGenerator, {
  ACTION_BUTTON_TYPES as ABT,
  pushToParams,
  requestTo,
} from "../../components/action-buttons/ActionButtonGenerator";
import CrudMain from "../../components/crud/CrudMain";
import FormikForm from "../../components/crud/FormikForm";
import Select from "../../components/form-fields/Select";
import TextInput from "../../components/form-fields/TextInput";
import ListComponent from "../../components/list/ListComponent";
import Main from "../../components/main/Main";
import { useTranslation } from 'react-i18next';                   /* Added Line */

export default function DemandDocType() {
  const [showModal, setShowModal] = useState(false);
  const [configData, setConfigData] = useState(null);
  const [refreshList, setRefreshList] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  const [departmanId, setDepartmanId] = useState(null);
  const [t, i18n] = useTranslation();         /* Added Line */

  const validationSchema = yup.object({});

  const arrangeBeforePersist = (values) => {
    let payload = {
      talepTurId: values.talepTurId,
    //   departmentId: values.departmentId,
      evrakTipi: values.evrakTipi,
      evrakTipiEn: values.evrakTipiEn,
      evrakTipiTr: values.evrakTipiTr,
      id: values.id,
    };
    return payload;
  };

  const adaptDataForUpdate = (data) => {
    if (data.departmentId) {
        onDepartmentChanged(data.departmentId)
    }
    let adaptedData = {
      talepTurId: data.talepTurId,
      departmentId: data.departmentId,
      evrakTipi: data.evrakTipi,
      evrakTipiEn: data.evrakTipiEn,
      evrakTipiTr: data.evrakTipiTr,
      id: data.id,
    };
    setInitialValues(adaptedData);
  };

  const onUpdateButtonClicked = (selectedRow) => {
    setShowModal(true);
    setIsUpdating(true);
    setSelectedRow(selectedRow);
  };

  const onAddButtonClicked = () => {
    setShowModal(true);
    setIsUpdating(false);
    setInitialValues({});
  };

  const onDepartmentChanged = (value) => {
    setDepartmanId(value);
  };

  return (
    <Main>
      <div className="row">
        <div className="col-xl-12 col-xxl-12">
          <CrudMain
            onAddButtonClicked={onAddButtonClicked}
            showModal={showModal}
            setShowModal={setShowModal}
            title={t("pageTitleofDemandCreate.evrakTipi")}
          >
            <FormikForm
              isUpdating={isUpdating}
              entityId={selectedRow && selectedRow.id}
              entityFetchId="id"
              configParameterName="id"
              configParameterValue={departmanId}
              configReqType={"POST"}
              endPointUrl="evrak-tipi/create"
              fetchPointUrl="evrak-tipi/find"
              editPointUrl="evrak-tipi/update"
              configPointUrl="evrak-tipi/config"
              arrangeBeforePersist={arrangeBeforePersist}
              adaptDataForUpdate={adaptDataForUpdate}
              setConfigData={(data) => setConfigData(data)}
              initialValues={initialValues}
              validationSchema={validationSchema}
              closeModal={() => setShowModal(false)}
              refreshList={() => setRefreshList(!refreshList)}
            >
              <Field
                name="departmentId"
                label={t("documentStates.departman")}
                colNumber="12"
                component={Select}
                options={configData && configData.department}
                onChangeFunc={(opt) => onDepartmentChanged(opt)}
              />
              <Field
                name="talepTurId"
                label={t("documentStates.talepTürleri")}
                colNumber="12"
                component={Select}
                options={configData && configData.talepTur}
              />
              <Field
                name="evrakTipiTr"
                label={t("demandDocType.evrakTipiTr")}
                colNumber="12"
                component={TextInput}
              />
              <Field
                name="evrakTipiEn"
                label={t("demandDocType.evrakTipiEn")}
                colNumber="12"
                component={TextInput}
                onlyEnglish={true}
              />
            </FormikForm>
          </CrudMain>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <ListComponent
            entityName="evrak-tipi"
            endpoint="evrak-tipi/list"
            keyField="id"
            refreshList={refreshList}
            columns={[
              {
                dataField: "id",
                text: "ID",
                sort: true,
                headerClasses: "id-header",
              },
              {
                dataField: "evrakTipiTr",
                text: `${t("demandDocType.evrakTipiTr")}`,
                sort: true,
              }, {
                dataField: "evrakTipiEn",
                text: `${t("demandDocType.evrakTipiEn")}`,
                sort: true,
              },
              {
                dataField: "talepTur.talepTuru",
                text: `${t("demandList.talepTuru")}`,
                sort: true,
              },
            ]}
            actionButtonsObject={{
              actions: [
                pushToParams(ABT.EDIT, onUpdateButtonClicked),
                requestTo(ABT.DELETE, "evrak-tipi/delete"),
              ],
              generator: DefaultActionButtonGenerator,
            }}
          />
        </div>
      </div>
    </Main>
  );
}
